/**
 * Дополняет строку нулями слева до указанной длины
 *
 * @param value Значение для форматирования
 * @param length Целевая длина строки
 * @returns Отформатированная строка
 */
export function padZeroStart(value: number, length = 2): string {
  return String(value).padStart(length, '0');
}
